/**
 * Admin Verification Management Page
 * Dedicated page for reviewing verification applications
 */

import React from 'react';
import {
  Container,
  Box,
  Typography,
  Breadcrumbs,
  Link
} from '@mui/material';
import { NavigateNext, VerifiedUser } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import VerificationReviewDashboard from '../components/admin/VerificationReviewDashboard';

const AdminVerificationPage = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      {/* Breadcrumbs */}
      <Breadcrumbs 
        separator={<NavigateNext fontSize="small" />} 
        sx={{ mb: 2 }}
      >
        <Link
          underline="hover"
          sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
          color="inherit"
          onClick={() => navigate('/admin')}
        >
          Admin Dashboard
        </Link>
        <Typography
          sx={{ display: 'flex', alignItems: 'center' }}
          color="text.primary"
        >
          <VerifiedUser sx={{ mr: 0.5 }} fontSize="inherit" />
          Verification Review
        </Typography>
      </Breadcrumbs>

      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" sx={{ fontWeight: 600, mb: 1 }}>
          Verification Application Review
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Review and approve/reject verification applications
        </Typography>
      </Box>

      {/* Dashboard */}
      <VerificationReviewDashboard />
    </Container>
  );
};

export default AdminVerificationPage;



